/* emvy theme — vanilla JS */
(function () {
  'use strict';

  /* ── nav scroll ─────────────────────────────────────────────── */
  const header = document.getElementById('emvy-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── mobile menu ────────────────────────────────────────────── */
  const burger = document.getElementById('emvy-burger');
  const mobileMenu = document.getElementById('emvy-mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
    });
    mobileMenu.querySelectorAll('a').forEach((a) =>
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      })
    );
  }

  /* ── contact form ───────────────────────────────────────────── */
  const contactForm = document.getElementById('emvy-contact-form');
  const contactSuccess = document.getElementById('emvy-contact-success');
  if (contactForm && contactSuccess) {
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      try {
        const res = await fetch('/contact', { method: 'POST', body: new FormData(contactForm) });
        if (res.ok) {
          contactForm.classList.add('hidden');
          contactSuccess.classList.remove('hidden');
        } else {
          contactForm.submit();
        }
      } catch (_) {
        contactForm.submit();
      }
    });
  }

  /* ── product image gallery ──────────────────────────────────── */
  window.emvySetProductImage = function (btn) {
    const img  = document.getElementById('emvy-product-img');
    const link = document.getElementById('emvy-product-img-link');
    if (img) img.src = btn.dataset.src;
    if (link) link.href = btn.dataset.src.replace(/width=\d+/, 'width=1800');
    document.querySelectorAll('.emvy-product__thumb').forEach((t) => t.classList.remove('active'));
    btn.classList.add('active');
  };

  /* ── product variant selector ───────────────────────────────── */
  const variantSelects = document.querySelectorAll('.emvy-variant-select');
  if (variantSelects.length && window.emvyProductVariants) {
    const variants = window.emvyProductVariants;

    const getSelectedOptions = () =>
      Array.from(variantSelects).map((s) => s.value);

    const findVariant = (options) =>
      variants.find((v) =>
        v.options.every((opt, i) => opt === options[i])
      );

    const updateDisplay = (variant) => {
      if (!variant) return;

      /* price */
      const priceWrap = document.getElementById('emvy-price-display');
      if (priceWrap) {
        const fmt = (cents) =>
          (cents / 100).toLocaleString('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          priceWrap.innerHTML =
            `<span class="emvy-product__price-compare">${fmt(variant.compare_at_price)}</span>
             <span class="emvy-product__price-sale">${fmt(variant.price)}</span>
             <span class="emvy-badge emvy-badge--brat">-${pct}%</span>`;
        } else {
          priceWrap.innerHTML = `<span class="emvy-product__price-current">${fmt(variant.price)}</span>`;
        }
      }

      /* hidden variant id */
      const vidInput = document.getElementById('emvy-variant-id');
      if (vidInput) vidInput.value = variant.id;

      /* URL update */
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      /* add-to-cart button */
      const atcWrap = document.getElementById('emvy-atc-wrap');
      if (atcWrap) {
        if (variant.available) {
          atcWrap.innerHTML =
            `<button type="submit" class="emvy-btn emvy-btn--primary" style="width:100%;justify-content:center;">
               add to cart
             </button>`;
        } else {
          atcWrap.innerHTML =
            `<button type="button" disabled class="emvy-btn emvy-btn--secondary emvy-btn--disabled" style="width:100%;justify-content:center;">
               sold out
             </button>`;
        }
      }

      /* featured image */
      if (variant.featured_image) {
        const img = document.getElementById('emvy-product-img');
        if (img) img.src = variant.featured_image.src;
      }
    };

    variantSelects.forEach((select) => {
      /* update option display label */
      select.addEventListener('change', () => {
        const idx = select.dataset.optionIndex;
        const lbl = document.getElementById(`emvy-option-val-${idx}`);
        if (lbl) lbl.textContent = select.value;
        updateDisplay(findVariant(getSelectedOptions()));
      });
    });
  }

  /* ── qty stepper (product page) ─────────────────────────────── */
  window.emvyQtyStep = function (btn, delta) {
    const row   = btn.closest('.emvy-qty');
    const input = row.querySelector('input[type="number"]');
    if (!input) return;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    input.value = next;
  };

  /* ── cart quantity (cart page) ──────────────────────────────── */
  window.emvyCartQty = async function (btn, key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!res.ok) throw new Error('cart update failed');
      const cart = await res.json();
      /* reload to keep Liquid cart totals accurate */
      window.location.reload();
    } catch (_) {
      window.location.reload();
    }
  };

})();
